import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER } from '@angular/core';
import {AppComponent} from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {NavigationEnd, Router} from '@angular/router';
import { SharedModule } from './shared/shared.module';
import {ElementControlComponent} from './sfd/common/sub-atomic/element-control/element-control.component';
import {ElementControlFormWrapperComponent} from './sfd/common/sub-atomic/element-control-form-wrapper/element-control-form-wrapper.component';
import {CustomPageLabelComponent} from './sfd/common/sub-atomic/custom-page-label/custom-page-label.component';
import {CardComponent} from './sfd/common/organisms/card/card.component';
import {ErrorMessagingService} from './shared/services/error-messaging.service';
import {FooterContentService} from './shared/services/footer.service';
import {AuthStateService} from './shared/services/auth-state.service';
// import {ValidateEmailDirective} from './shared/validators/ValidateEmail.directive';
// import {ValidateMinLength} from './shared/validators/validateMinLength.directive';
// import {ValidatePolicyNumber} from './shared/validators/validatePolicyNumber.directive';
// import {ValidateAlphaNumericOnlyDirective} from './shared/validators/alpha-numeric-only.directive';
// import {ValidateNumberOnlyDirective} from './shared/validators/number-only.directive';
// import {ValidateAlphaOnlyDirective} from './shared/validators/ValidateAlphaOnly.directive';
import {LinkDirective} from './shared/directives/directives';
import {TealiumDataService} from './shared/services/tealium/tealium-data.service';
import {TealiumUtagService} from './shared/services/tealium/utag.service';
import {TealiumModule} from './shared/modules/tealium.module';
import {SessionService} from './shared/services/tealium/session.service';
import {ElementPropertyDirective} from './shared/directives/element-property.directive';


/** import component file*/

import {SfdManagementService} from './shared/services/sfd-management.service';
import {SfdPleaseCallComponent} from './sfd/sfd-please-call/sfd-please-call.component';
import {HeaderComponent} from './sfd/common/molecules/header/header.component';
import {FooterComponent} from './sfd/common/molecules/footer/footer.component';
import {AuthService} from './auth.service';
import {SharedDataService} from './shared-data.service';
import {CustomCookieService} from './shared/services/customCookieService';
import {SessionManagementService} from './shared/services/session-management.service';
import {StorageManagementService} from './shared/services/storage-management.service';
import {InactivityTimerComponent} from './inactivity-timer.component';
import {AppIDRoutingService} from './routing.service';
import { SfdDefaultComponent } from './sfd/sfd-default/sfd-default.component';
import { ButtonComponent } from './sfd/common/sub-atomic/button/button.component';
import { AppInfoComponent } from './sfd/app-info/app-info.component';
import {MessageRibbonService} from './shared/services/message-ribbon.service';
import { CustomEventService } from './shared/services/tealium/custom-event.service';
import { SfdConfirmationComponent } from './sfd/sfd-confirmation/sfd-confirmation.component';
import { EncryptUtil } from './shared/utils/EncryptUtil';
import {SfdCustomErrorMessageComponent} from './sfd/sfd-custom-error-message/sfd-custom-error-message.component';
import { httpInterceptorProviders } from './shared/intercepter';
import { AuthGuard } from './shared/services/auth.guard';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { MSAL_CONFIG_MAP } from '../environments/environment';
import { Configuration, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { env } from '../environments/environment-loader';
import { HukModule } from 'huk-angular-bindings';

export function initializeApp(customCookieService: CustomCookieService) {
   return () => customCookieService.loadCIAMSessionInfo();
}

export function MSALInstanceFactory(customCookieService: CustomCookieService): PublicClientApplication {
  const msalRealm = customCookieService.sessionInfo;
  console.log("MSAL Instance Factory Realm -", msalRealm);
  if (msalRealm === undefined || msalRealm === null) {
    console.log("MSALInstanceFactory: sessionInfo is undefined. Defaulting to Agency MSAL Config.");
    return new PublicClientApplication(GET_MSAL_CONFIG('/customers'));
  } else if (msalRealm === '/partners') {
    console.log("Defaulting to Partner MSAL Config -" + JSON.stringify(GET_MSAL_CONFIG(msalRealm)));
    return new PublicClientApplication(GET_MSAL_CONFIG(msalRealm));
  } else if (msalRealm === '/customers') {
    console.log("Defaulting to Customer MSAL Config -" + JSON.stringify(GET_MSAL_CONFIG(msalRealm)));
    return new PublicClientApplication(GET_MSAL_CONFIG(msalRealm));
  } else {
    console.log("Defaulting to Agency MSAL Config -" + JSON.stringify(GET_MSAL_CONFIG(msalRealm)));
    return new PublicClientApplication(GET_MSAL_CONFIG(msalRealm));
  }
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [... MSAL_CONFIG_MAP.scopes],
      onRedirectNavigate: (url: string) => {        
        return true;
      }
    },
    loginFailedRoute: '/'
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();  
  protectedResourceMap.set('https://int-apis-hig.thehartford.com',  MSAL_CONFIG_MAP.scopes);
  protectedResourceMap.set('https://qa-apis-hig.thehartford.com',  MSAL_CONFIG_MAP.scopes);
  protectedResourceMap.set('https://APIs-hig.thehartford.com',  MSAL_CONFIG_MAP.scopes);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function GET_MSAL_CONFIG(realm: string): Configuration {
    const host = env.envName;
    switch (host) {
      case 'dev1':
        return MSAL_CONFIG_MAP['dev1'][realm];
      case 'qa1':
        return MSAL_CONFIG_MAP['qa1'][realm];
      case 'sqa1':
        return MSAL_CONFIG_MAP['sqa1'][realm];
      case 'pt1':
        return MSAL_CONFIG_MAP['pt1'][realm];
      case 'prod':
        return MSAL_CONFIG_MAP['prod'][realm];
      case 'localhost':
        return MSAL_CONFIG_MAP['localhost'][realm];
      default:
        return MSAL_CONFIG_MAP['dev1'][realm];
    }
  }

@NgModule({ declarations: [
        AppComponent,
        ElementControlComponent,
        ElementControlFormWrapperComponent,
        CustomPageLabelComponent,
        HeaderComponent,
        FooterComponent,
        ButtonComponent,
        CardComponent,
        ElementPropertyDirective,
        LinkDirective,
        SfdPleaseCallComponent,
        InactivityTimerComponent,
        SfdDefaultComponent,
        AppInfoComponent,
        SfdConfirmationComponent,
        SfdCustomErrorMessageComponent
    ],
    bootstrap: [AppComponent, MsalRedirectComponent], imports: [BrowserModule,
        TealiumModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        CommonModule,
        SharedModule,
      HukModule.forRoot({ mode: 'refresh' }),
        MsalModule], providers: [
        CustomCookieService,
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [CustomCookieService],
            multi: true
        },
        SharedDataService,
        AuthService,
        SfdManagementService,
        ErrorMessagingService,
        FooterContentService,
        AuthStateService,
        TealiumUtagService,
        TealiumDataService,
        SessionService,
        SessionManagementService,
        StorageManagementService,
        MessageRibbonService,
        CustomEventService,
        AppIDRoutingService,
        EncryptUtil,
        AuthGuard,
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
            deps: [CustomCookieService]
        },
        {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory
        },
        {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MSALInterceptorConfigFactory
        },
        httpInterceptorProviders,
        { provide: 'Window', useValue: window },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())
    ] })
export class AppModule {
constructor(private router: Router, private tealium: TealiumUtagService) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.tealium.view();
      }
    });
  }

}
